import { Col, Row } from 'antd';
import { ColoredHeaderCard } from 'components/common/ColoredHeaderCard';
import { useFormikContext } from 'formik';
import { SparingRequestPayload } from 'models/SparingRequests';
import { DefectiveReturnsHeader } from 'pages/Defective/DefectiveReturnsHeader';
import { DefectiveReturnsTable } from 'pages/Defective/DefectiveReturnsTable';
import { colors, toRgba } from 'styles/colors';

export const DefectiveReturnsStep = (): JSX.Element => {
  const { values } = useFormikContext<SparingRequestPayload>();

  return (
    <Row gutter={[12, 12]}>
      <Col xs={24} xl={8} style={{ marginBottom: 30 }}>
        <DefectiveReturnsHeader />
      </Col>
      <Col xs={24} xl={16} style={{ marginBottom: 30 }}>
        <ColoredHeaderCard title="Line Items" headerColor={toRgba(colors.robinEggBlue, 0.4)}>
          <DefectiveReturnsTable />
        </ColoredHeaderCard>
      </Col>
    </Row>
  );
};
